import React, {Component, Fragment} from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import MasterPackageHeader from "./MasterPackageHeader";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {v4 as uuidv4} from 'uuid';
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {initialDataDetail, tableColumns} from "../config/config";
import Api from "../../../../Services/Api";
import {ACTIVITY_TYPE, HttpStatus} from "../../../common/Constants";
import {mapToObjectDDL} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {getCategoryType, getDataDetail, validateDataItem} from "../util";
import {fetchDataItem} from "../service";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";

class MasterPackageModifying extends Component {
    constructor(props) {
        super(props);
        this.listDataName = {KSU: "listKSU", Hadiah: "listGift", OtherItem: "listOtherItem", Part: "listPart"}
        this.listTabPanel = ["KSU", "Hadiah", "OtherItem", "Part"];
        this.state = {
            loading: false,
            warningModalVisible: false,
            activeTab: "KSU",
            errorListCabang: undefined,
            errorGracePeriod: undefined,
            errorStartDate: undefined,
            errorEndDate: undefined,
            tableColumn: [],
            dataTable: {
                KSU: [],
                Hadiah: [],
                OtherItem: [],
                Part: [],
            },
            dataDetailSaved: [],
            selectedRow: null,
            dataCategory: [],
            dataItem: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        Object.entries(this.listDataName).forEach(([key, value]) => {
            this.props.setValue(value, this.state.dataDetailSaved[key]);
        });

        if (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)) {
            const id = await this.fetchMasterPackageId();
            this.props.setValue("packageId", id);
        }

        if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
            await this.fetchDataDetail();
        }

        const categoryType = getCategoryType(this.state.activeTab);
        const listCategory = await this.fetchDataCategory({
            paramFilters: {bizparCategory: categoryType}
        })
        this.setState({
            tableColumn: tableColumns.detailPage(
                this.handleSaveRow,
                this.handleEditRow,
                this.handleCancelRow,
                this.handleDeleteRow,
                this.handleValueChange,
                this.handleCategoryChange,
                this.handleItemChange,
                listCategory,
                this.state.dataItem,
                this.state.activeTab,
            )[this.state.activeTab],
            dataCategory: listCategory,
        });

        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevState.dataTable !== this.state.dataTable) {
            Object.entries(this.listDataName).forEach(([key, value]) => {
                this.props.setValue(value, this.state.dataDetailSaved[key]);
            });
        }

        if (prevState.activeTab !== this.state.activeTab) {
            this.handleTriggerLoading();
            const categoryType = getCategoryType(this.state.activeTab);
            const listCategory = await this.fetchDataCategory({
                paramFilters: {bizparCategory: categoryType}
            })
            this.setState((prevState) => ({
                ...prevState,
                tableColumn: tableColumns.detailPage(
                    this.handleSaveRow,
                    this.handleEditRow,
                    this.handleCancelRow,
                    this.handleDeleteRow,
                    this.handleValueChange,
                    this.handleCategoryChange,
                    this.handleItemChange,
                    listCategory,
                    this.state.dataItem,
                    this.state.activeTab,
                )[this.state.activeTab],
                dataCategory: listCategory,
            }));
            this.handleTriggerLoading();
        }

        if (prevState.dataItem !== this.state.dataItem) {
            this.setState((prevState) => ({
                ...prevState,
                tableColumn: tableColumns.detailPage(
                    this.handleSaveRow,
                    this.handleEditRow,
                    this.handleCancelRow,
                    this.handleDeleteRow,
                    this.handleValueChange,
                    this.handleCategoryChange,
                    this.handleItemChange,
                    prevState.dataCategory,
                    prevState.dataItem,
                    this.state.activeTab,
                )[this.state.activeTab]
            }));
        }
    }

    handleWarningModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleSubmit = () => {
        let valid = true;
        if (!this.props.validate()) {
            valid = false;
        }

        if (!this.validateListCabang()) {
            valid = false;
        }

        if (!this.validateGracePeriod()) {
            valid = false;
        }

        if (valid) {
            this.props.onSubmit(this.props.controls);
        }
    };

    handleAddRow = async () => {
        const newData = {
            id: uuidv4(),
            ...initialDataDetail,
        }

        this.setState((prevState) => ({
            ...prevState,
            dataTable: {
                ...prevState.dataTable,
                [this.state.activeTab]: [...prevState.dataTable[this.state.activeTab], newData],
            }
        }));
    };

    handleSaveRow = (index) => {
        let errors = validateDataItem(this.state.dataTable[this.state.activeTab][index]);
        if (!R.isNil(errors) && !R.isEmpty(errors)) {
            this.handleWarningModalVisibility();
            return;
        }

        this.setState((prevState) => {
            const newData = [...prevState.dataTable[this.state.activeTab]];
            newData[index] = {
                ...newData[index],
                saved: !newData[index].saved,
            };

            const mergedData = Array.from(
                newData.reduce((map, item) => {
                    const key = item.kode;
                    const existing = map.get(key);
                    if (existing) {
                        existing.jumlah += Number(item.jumlah);
                    } else {
                        map.set(key, {...item, jumlah: Number(item.jumlah)});
                    }
                    return map;
                }, new Map()).values()
            );

            return {
                ...prevState,
                dataTable: {
                    ...prevState.dataTable,
                    [this.state.activeTab]: [...mergedData],
                },
                dataDetailSaved: {
                    ...prevState.dataDetailSaved,
                    [this.state.activeTab]: [...mergedData],
                },
                selectedRow: !R.isNil(prevState.selectedRow)
                    ? {
                        ...prevState.selectedRow,
                        [this.state.activeTab]: Object.values(prevState.selectedRow?.[this.state.activeTab] || [])
                            .filter(item => item.id !== newData[index].id),
                    }
                    : {
                        ...prevState.selectedRow,
                    },
            };
        });
    }

    handleEditRow = async (index) => {
        this.setState((prevState) => {
            const newState = [...prevState.dataTable[this.state.activeTab]];
            const savedPrevValue = newState[index];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            return {
                ...prevState,
                dataTable: {
                    ...prevState.dataTable,
                    [this.state.activeTab]: newState,
                },
                selectedRow: {
                    ...prevState.selectedRow,
                    [this.state.activeTab]: {
                        ...prevState.selectedRow?.[this.state.activeTab],
                        [index]: savedPrevValue
                    }
                },
            };
        });

        const categoryId = this.state.dataTable[this.state.activeTab][index].category?.value;
        await this.fetchDataItem(index, categoryId);
    }

    handleCancelRow = (index) => {
        this.setState((prevState) => {
            let dataTable = prevState.dataTable[this.state.activeTab];
            if (R.isNil(prevState.selectedRow) || R.isEmpty(prevState.selectedRow) || R.isEmpty(prevState.selectedRow?.[this.state.activeTab])) {
                dataTable = [
                    ...prevState.dataTable[this.state.activeTab].filter((_, idx) => idx !== index)
                ];
            } else {
                dataTable[index] = Object.values(prevState.selectedRow[this.state.activeTab])
                    .find(item => item.id === dataTable[index].id);
            }

            return {
                ...prevState,
                dataTable: {
                    ...prevState.dataTable,
                    [this.state.activeTab]: dataTable,
                },
                selectedRow: !R.isNil(prevState.selectedRow) && !R.isEmpty(prevState.selectedRow)
                    ? {
                        ...prevState.selectedRow,
                        [this.state.activeTab]: Object.values(prevState.selectedRow[this.state.activeTab])
                            .filter(item => item.id !== dataTable[index].id),
                    }
                    : null,
            };
        });
    }

    handleDeleteRow = (index) => {
        this.setState((prevState) => ({
            ...prevState,
            dataTable: {
                ...prevState.dataTable,
                [this.state.activeTab]: [
                    ...prevState.dataTable[this.state.activeTab].filter((_, idx) => idx !== index)
                ],
            },
            dataDetailSaved: {
                ...prevState.dataDetailSaved,
                [this.state.activeTab]: [
                    ...prevState.dataDetailSaved[this.state.activeTab].filter((_, idx) => idx !== index)
                ],
            }
        }));
    }

    handleValueChange = (index, name, value) => {
        this.setState((prevState) => {
            const newState = [...prevState.dataTable[this.state.activeTab]];
            newState[index] = {
                ...newState[index],
                [name]: value,
            };

            return {
                ...prevState,
                dataTable: {
                    ...prevState.dataTable,
                    [this.state.activeTab]: newState,
                },
            };
        });
    }

    handleCategoryChange = async (index, name, value) => {
        this.setState((prevState) => {
            const newState = [...prevState.dataTable[this.state.activeTab]];
            newState[index] = {
                ...newState[index],
                [name]: value,
                name: null,
                kode: null,
                satuan: null,
            };

            return {
                ...prevState,
                dataTable: {
                    ...prevState.dataTable,
                    [this.state.activeTab]: newState,
                },
            };
        });

        this.handleTriggerLoading();
        await this.fetchDataItem(index, value.value);
        this.handleTriggerLoading();
    }

    handleItemChange = (index, name, value) => {
        this.setState((prevState) => {
            const newState = [...prevState.dataTable[this.state.activeTab]];
            newState[index] = {
                ...newState[index],
                [name]: value,
                kode: value.value,
                satuan: value.satuan,
            };

            return {
                ...prevState,
                dataTable: {
                    ...prevState.dataTable,
                    [this.state.activeTab]: newState,
                },
            };
        });
    }

    handleTabChange = (index) => {
        this.setState((prevState) => ({
            ...prevState,
            activeTab: index,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }))
    }

    validateListCabang = () => {
        const {packageAllCabang: allCabang, packageSpecificCabang: selCabang, listCabang} = this.props.controls;

        if (R.isNil(allCabang.value) && R.isNil(selCabang.value)) {
            this.setState({errorListCabang: "Field belum diisi"});
            return false;
        }

        if (!allCabang.value && !selCabang.value) {
            this.setState({errorListCabang: "Field belum diisi"});
            return false;
        }

        if (!allCabang.value && selCabang.value && (R.isNil(listCabang.value) || listCabang.value.length === 0)) {
            this.setState({errorListCabang: "Field belum diisi"});
            return false;
        }

        this.setState({errorListCabang: null});
        return true;
    }

    validateGracePeriod = () => {
        const {packageHasGracePeriod, packageStartDate, packageEndDate} = this.props.controls;
        let valid = true;
        if (!packageHasGracePeriod?.value) {
            if (R.isNil(packageStartDate?.value)) {
                this.setState({errorStartDate: "Field belum diisi"});
                valid = false;
            } else {
                this.setState({errorStartDate: null});
            }
            if (R.isNil(packageEndDate?.value)) {
                this.setState({errorEndDate: "Field belum diisi"});
                valid = false;
            } else {
                this.setState({errorEndDate: null});
            }
        } else {
            this.setState({errorStartDate: null});
            this.setState({errorEndDate: null});
        }
        return valid;
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchMasterPackageId = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateMasterPackageId();
            return res.ok ? res.data.data : null;
        } catch (error) {
            console.log("error: ", error);
        }
    }

    fetchDataDetail = async () => {
        let id = this.props.controls.packageId.value;
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterPackageById,
            menuName: "Master Package",
            setError: this.props.setError,
            args: contructQueryParam({idPackage: id}),
        })
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            const listVariant = res.data.data.listVariant?.map(
                item => mapToObjectDDL(item.kodeVariant, item.kodeVariant)
            );
            this.props.setValue("listVariant", listVariant);

            if (R.equals(this.props.controls.listCabang.value, "ALL")) {
                this.props.setValue("packageAllCabang", true);
                this.props.setValue("packageSpecificCabang", false);
                this.props.setValue("listCabang", []);
            } else {
                const listCabang = res.data.data.listCabang?.map(
                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                );
                this.props.setValue("packageAllCabang", false);
                this.props.setValue("packageSpecificCabang", true);
                this.props.setValue("listCabang", listCabang);
            }

            this.setState((prevState) => ({
                ...prevState,
                dataTable: {
                    ...prevState.dataTable,
                    KSU: getDataDetail("KSU", res.data.data.listKSU),
                    Hadiah: getDataDetail("Hadiah", res.data.data.listGift),
                    OtherItem: getDataDetail("OtherItem", res.data.data.listOtherItem),
                    Part: getDataDetail("Part", res.data.data.listPart),
                },
                dataDetailSaved: {
                    ...prevState.dataDetailSaved,
                    KSU: getDataDetail("KSU", res.data.data.listKSU),
                    Hadiah: getDataDetail("Hadiah", res.data.data.listGift),
                    OtherItem: getDataDetail("OtherItem", res.data.data.listOtherItem),
                    Part: getDataDetail("Part", res.data.data.listPart),
                },
                pagination: {
                    ...prevState.pagination,
                    totalData: res.data.data.length,
                }
            }))
        }
    }

    fetchDataCategory = async (body) => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam(body);
            if (res.ok) {
                return res.data.data
            }
        } catch (error) {
            console.log("errors: ", error);
        }

        return null;
    }

    fetchDataItem = async (index, categoryId) => {
        const res = await fetchDataItem(this.state.activeTab, categoryId);
        this.setState((prevState) => ({
            ...prevState,
            dataItem: {
                ...prevState.dataItem,
                [this.state.activeTab]: {
                    ...prevState.dataItem[this.state.activeTab],
                    [index]: res
                }
            },
        }));
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <>
                <SimpleModal
                    title="Detail Package"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <MasterPackageHeader
                                {...this.props}
                                errorListCabang={this.state.errorListCabang}
                                errorStartDate={this.state.errorStartDate}
                                errorEndDate={this.state.errorEndDate}
                            />

                            <FlexView vAlignContent="center" className="margin-bottom-10px">
                                <SimpleButton
                                    className={"btn btn-plus background-red margin-left-none"}
                                    onClick={this.handleAddRow}
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    text={"Tambah"}
                                />
                            </FlexView>

                            <Tabs onSelect={(index) => this.handleTabChange(this.listTabPanel[index])}>
                                <TabList>
                                    {this.listTabPanel.map((tab, index) => (
                                        <Tab key={index} id={`button_navigate_${tab.toLowerCase()}`}>
                                            {R.equals(tab, "OtherItem") ? "Barang Lain" : tab}
                                        </Tab>
                                    ))}
                                </TabList>
                                {this.listTabPanel.map((item, index) => {
                                    return (
                                        <TabPanel key={`${index}-${item}`}>
                                            <SimpleDataTable
                                                key={`${pagination.totalData}-${pagination.page}`}
                                                data={this.state.dataTable[this.state.activeTab]}
                                                columns={this.state.tableColumn}
                                                toCount={pagination.totalData}
                                                rowsPerPage={pagination.limit}
                                                page={pagination.page - 1}
                                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                                            />
                                        </TabPanel>
                                    );
                                })}
                            </Tabs>

                            <div style={{textAlign: "right", marginTop: "10px"}}>
                                <SimpleButton
                                    text="Simpan"
                                    type="button"
                                    onClick={() => this.handleSubmit()}
                                />
                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.warningModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    Ada field data yang perlu diisi atau tidak sesuai kriteria isian.
                                    <br/>
                                    Mohon periksa kembali.
                                </p>
                            </div>
                        }
                        additionalButtons={
                            <Fragment>
                                <FlexView>
                                    <SimpleButton
                                        text="OK"
                                        secondary
                                        onClick={() => this.handleWarningModalVisibility()}
                                    />
                                </FlexView>
                            </Fragment>
                        }
                        visible={this.state.warningModalVisible}
                        onClickClose={this.handleWarningModalVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default withFormGroup(MasterPackageModifying);